import { IsDateString, IsOptional, IsString } from 'class-validator';

export class PullSessionSlateDto {
	@IsString()
	eventId: string;

	@IsString()
	groupId: string;

	@IsString()
	sessionName: string;

	@IsOptional()
	@IsString()
	roundGroup?: string;

	@IsDateString()
	openTime: string;

	@IsDateString()
	closeTime: string;
}
